<template>
  <div class="stages">
    <div class="container stages-wrapper">
      <div class="stages__svg">
        <img class="stages__svg__sticky" src="/ru/lg-travel/images/desktop/stages/stage_thrid.svg" alt="">
      </div>
      <div
          class="stages-images"
          v-for="item in content.images"
          :key="item.alt"
      >
      <img
           :src="item.src"
          :alt="item.alt"
      >
      </div>
    </div>
    <div class="stages-footer">
      <div class="stages-footer-title">Выберите страну</div>
      <div class="stages-footer-select">
        <Select />
      </div>
      <div class="content">
        <div class="content__text">
          <span v-if="distance === '> 4500 км'">Ух, как далеко! </span>
          <span v-if="distance === '> 4500 км'">Не так важно, насколько далеко находится выбранная вами точка. Важно, что вы можете выиграть путешествие в эту страну!</span>
          <span v-else>Расстояние</span>
          <span class="content__text__size" v-if="distance === '> 4500 км'">∞</span>
<!--          <span class="content__text__size" v-else>{{ distance }}</span>-->
          <span class="content__text__size" v-else>-</span>
        </div>
        <div class="footer__left__image">
          <img class="footer__left__image__svg" :src="`/ru/lg-travel/images/desktop/map/countries/${selectedCountry}.svg`" alt="map">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Select from '../elements/select/Select'
import {mapState} from "vuex";
export default {
  props: ['content'],
  components: {Select},
  name: "Stages",
  computed:{
    ...mapState({
      selectedCountry:"selectedCountry",
      distance: "distance"
    })
  }
}
</script>

<style scoped lang="scss">
@import "stages";
</style>